import { render } from "./SaveCustomer.vue?vue&type=template&id=126f1c0a"
import script from "./SaveCustomer.vue?vue&type=script&lang=js"
export * from "./SaveCustomer.vue?vue&type=script&lang=js"

import exportComponent from "/Users/balbeer.yadav/Development/lmthrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__